import axios from '../../utils/AxiosUtils';
import { LOAD_RESTRICTIONS_SUCCESS, LOADING } from "../types";
import MessageUtils from "../../utils/MessageUtils";
import * as i18n from "i18next";

export const loadRestrictions = () => {
    return (dispatch, getState) => {
        doRestrictions(dispatch, getState, false);
    }
}

export const doRestrictions = (dispatch, getState, isUpdate, updateResponse) => {
    if (isUpdate) {
        const updateMessage = (updateResponse.data.restrict) ? i18n.t('actions:restrictionsActions.disableRestrictSuccess') : i18n.t('actions:restrictionsActions.enableRestrictSuccess');
        MessageUtils.dispatchSuccessMessage(dispatch, updateMessage);
    } else {
        dispatch({ type: LOADING, payload: true });
    }

    const url = `/system/restrict-actions`;

    axios().get(url)
        .then(response => loadRestrictionsSuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restrictionsActions.loadRestrictionsFailure')));
}

const loadRestrictionsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTRICTIONS_SUCCESS, payload: response.data });
}

export const updateRestriction = (restriction) => {
    return (dispatch, getState) => {
        doUpdateRestriction(restriction, dispatch, getState);
    }
}


export const doUpdateRestriction = (restriction, dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/system/restrict-action`;
    const data = restriction;

    axios().put(url, data)
        .then(response => loadRestrictionsUpdateSuccess(dispatch, getState, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restrictionsActions.updateRestrictionFailure')));
}


export const loadRestrictionsUpdateSuccess = (dispatch, getState, response) => {
    dispatch({ type: LOADING, payload: false });
    doRestrictions(dispatch, getState, true, response);
}



// WEBPACK FOOTER //
// ./src/actions/systemControl/RestrictionsActions.js